import { getStatePure } from '~src/state';
import { goToPage } from '~src/multipages';

export const goToLastPage = () => {
  const pages = getStatePure('pages');
  const totalPages = pages.length;
  const lastPageIndex = totalPages - 1;

  return goToPage(lastPageIndex);
};
